export enum FeatureFlag {
  SkipMoreTabletRequest = 'skipMoreTabletRequest',
  ShowLandingPage = 'showLandingPage',
  SkipCustomerCountSelection = 'skipCustomerCountSelection',
  UseSimplePaymentProcess = 'useSimplePaymentProcess',
  MenuDealsEnabled = 'menu_deals_enabled',
  MenuUpgradesEnabled = 'menu_upgrades_enabled',
  ShowOpenCartRecommendations = 'showOpenCartRecommendations',
  ShowAddToCartRecommendations = 'showAddToCartRecommendations',
  AvailableLanguages = 'availableLanguages',
  ShowLogo = 'showLogo',
  ShowReleaseTableInCompanion = 'showReleaseTableInCompanion',
  showRating = 'showRating',
  Gainback = 'gainback',
  /** Aera Companion kitchen/bar ticket print after successful order (flag = on/off). */
  KitchenTicketPrint = 'kitchenTicketPrint',
}

/** PostHog payload for KitchenTicketPrint — printer target only (no nested enabled). */
export interface KitchenPrinterTarget {
  host: string;
  port: number;
  width?: number;
  codePage?: string;
}
